export default __webpack_public_path__ + "static/media/CERIN Logo.c06cd8e8.png";